var mesh_data = [
  {
    "name":"不锈钢过滤网筛网",
	"pic":"Index/buxiugang.jpg",
    "list":[{
      "name":"平纹网"
    },{
      "name":"斜纹网"
    },{
      "name":"席型网"
    },{
      "name":"反差网"
    },{
      "name":"裹边网"
    },{
      "name":"轧花网"
    }]
  },
  {
    "name":"丝网深加工制品",
	"pic":"Index/shenjiagong.jpg",
    "list":[{
		"name":"圆形滤片"
		},{
		  "name":"方形滤片"
		},{
		  "name":"异形滤片"
		},{
		  "name":"编织网筒"
		},{
		  "name":"滤碗"
		},{
		  "name":"滤帽"
		}]
  },
  {
    "name":"装饰网系列",
	"pic":"Index/zhuangshiwang.jpg",
    "list":[{
      "name":"装饰网"
    }]
  }
]

export default mesh_data


// WEBPACK FOOTER //
// ./src/assets/data/mesh_data.js